/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ interval: NonNullable<unknown> }} Spaces_Scheduled_Sync_DefaultInputs */



/**
* | output |
* | --- |
* | "Default ({interval})" |
*
* @param {Spaces_Scheduled_Sync_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_default = /** @type {((inputs: Spaces_Scheduled_Sync_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Standard (${i?.interval})`)
	return /** @type {LocalizedString} */ (`Default (${i?.interval})`)
});